<template>
  <div id="app" :class="navBar?'nav-top':''">
    <van-nav-bar
      v-if="navBar"
      left-text="返回"
      fixed
      left-arrow
      @click-left="pageBack()"
    />
    <keep-alive>
      <router-view v-if="keepAlive" />
    </keep-alive>
    <router-view v-if="!keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      keepAlive: false,
      navBar: false
    }
  },
  watch: {
    $route: function(to) {
      this.keepAlive = to.meta.keepAlive || false
      if (to.path === '/') {
        this.navBar = false
      } else {
        this.navBar = true
      }
    }
  },
  mounted() {
    localStorage.setItem('_iosWXConfig_', location.href)
  },
  methods: {
    pageBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less">
.nav-top{
  padding-top: 46px;
}
.flex-column-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  .middle-box {
    flex: 1;
    overflow: auto;
  }
}
</style>
